export interface AgreementImportWizardState {
  currentStep: number;
  sessionId: string | null;
  activeContractId: string | null;
  /** Step to return to once the active contract's review is closed. */
  reviewReturnStep: number;
}

export const STEP_SESSION = 0;
export const STEP_UPLOAD = 1;
export const STEP_CONTRACTS = 2;
export const STEP_REVIEW = 3;
export const STEP_APPROVE = 4;
export const STEP_DONE = 5;

export const AGREEMENT_IMPORT_WIZARD_STEPS = [
  { key: 'session', step: STEP_SESSION },
  { key: 'upload', step: STEP_UPLOAD },
  { key: 'contracts', step: STEP_CONTRACTS },
  { key: 'review', step: STEP_REVIEW },
  { key: 'approve', step: STEP_APPROVE },
  { key: 'done', step: STEP_DONE },
] as const;

export const INITIAL_AGREEMENT_IMPORT_WIZARD_STATE: AgreementImportWizardState = {
  currentStep: STEP_SESSION,
  sessionId: null,
  activeContractId: null,
  reviewReturnStep: STEP_CONTRACTS,
};
